import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import {withStyles} from '@material-ui/core/styles';

import {NavPills} from '../../material-dashboard-pro-react/components';

import {ClientsManager, ClientsConfigurer} from '../../containers';
import {MessageBox, RenderOrEmpty} from '../../components';

import {TABS} from './constants';
import style from './style';

class Clients extends React.PureComponent {
  render() {
    const {accountInfo, classes} = this.props;

    return (
      <div className={classes.clients}>
        <RenderOrEmpty isShow={accountInfo.deviceAgentAllowed}>
          <NavPills
            color="secondary"
            className="root_fullScreen"
            wrapperClassName="tab__contentWrapper_fullScreen"
            contentClassName="tab__content_fullScreen"
            isSwipeable={false}
            tabs={[
              {
                tabButton: I18n.t(`clients.${TABS.MANAGE}.name`),
                tabContent: <ClientsManager />,
              },
              {
                tabButton: I18n.t(`clients.${TABS.CONFIGURE}.name`),
                tabContent: <ClientsConfigurer />,
              },
            ]}
          />
        </RenderOrEmpty>
        <RenderOrEmpty isShow={!accountInfo.deviceAgentAllowed} >
          <MessageBox message={I18n.t('clients.messages.agentUsingNotAllowed')} />
        </RenderOrEmpty>
      </div>
    );
  }
}

Clients.propTypes = {
  classes: PropTypes.object.isRequired,
  accountInfo: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  accountInfo: state.operatorLayoutReducer.accountInfo,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(Clients));
